<template>
  <ValidationObserver ref="internalNotes">
    <div>
      <h1 class="mb-5">Internal Notes</h1>
      <ValidationProvider v-slot="{ errors }" rules="required">
        <v-textarea
          :error-messages="showValidationErrors ? errors : ''"
          v-model="internalNotes"
          @change="handleChange"
          height="200"
          color="primary"
        />
      </ValidationProvider>
      <FileUpload
        @unselectFile="unselectFile"
        @selectFile="selectFile"
        :files="files"
        :fileTypes="['application/pdf']"
        disableAutoProceed
        customActions
        :isLoading="isAdjustingFileData"
      />
    </div>
  </ValidationObserver>
</template>

<script>
import FileUpload from "@/components/common/FileUpload";
import APIService from "@/services/APIService";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { getFilesFromUrls } from "@/utils/files";
import { first, isEmpty } from "lodash";
import { REMOVE_FILE } from "@/store/modules/data/actions";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  components: {
    FileUpload,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    feedback: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    if (!isEmpty(this.feedback)) {
      const { internalNotes, file } = this.feedback;
      this.internalNotes = internalNotes;
      if (file) {
        this.adjustFileData(file);
      }
    }
  },
  data() {
    return {
      isLoading: false,
      uppyInstance: null,
      currentFile: null,
      showValidationErrors: false,
      internalNotes: "",
      isAdjustingFileData: false,
      fileToRemove: null
    };
  },
  computed: {
    files() {
      return this.currentFile ? [this.currentFile] : [];
    }
  },
  methods: {
    ...mapActions({
      removeFile: REMOVE_FILE
    }),
    getAddFileUrl(feedbackId) {
      const host = APIService.host;
      return `${host}/interview-feedbacks/${feedbackId}/file`;
    },
    handleChange() {
      this.$emit("onChange", {
        internalNotes: this.internalNotes
      });
    },
    selectFile({ uppyInstance, file }) {
      this.uppyInstance = uppyInstance;
      this.currentFile = file;
    },
    unselectFile({ uppyInstance, file }) {
      if (file.url) {
        this.fileToRemove = file;
      }
      this.currentFile = null;
      uppyInstance.reset();
    },
    async adjustFileData(file) {
      this.isAdjustingFileData = true;
      const convertedFiles = await getFilesFromUrls([file]);
      this.currentFile = first(convertedFiles);
      this.isAdjustingFileData = false;
    },
    async handleFile(id) {
      if (this.currentFile && this.uppyInstance) {
        this.uppyInstance.setFileState(this.currentFile.id, {
          xhrUpload: { endpoint: this.getAddFileUrl(id) }
        });
        return this.uppyInstance && this.uppyInstance.upload(id);
      } else if (this.fileToRemove) {
        return this.removeFile(this.fileToRemove.url);
      }
    },
    async validateForm() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.internalNotes.validate();
      return isValid;
    }
  }
};
</script>

<style lang="scss"></style>
